export default "__VITE_ASSET__B_GCB7FO__"